import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

interface DeleteConfirmDialogProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    translations: {
        title: string;
        question: string;
        cancel: string;
        delete: string;
    };
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
    open,
    onCancel,
    onConfirm,
    translations
}) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
        >
            <DialogTitle id="delete-dialog-title">
                {translations.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="delete-dialog-description">
                    {translations.question}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {translations.cancel}
                </Button>
                <Button onClick={onConfirm} color="error">
                    {translations.delete}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;
